Solver.cart.age_confirm = async function (event) {
	if (!event || (event && !event.currentTarget)) return;

	const checked = event.currentTarget.checked;
	const btn = document.querySelector('.cart-btn');

	if (!btn) return;

	let req = null;

	if (checked) {
		req = await Solver.api.cart.notes('Customer Confirms Age 21 or Older');
		btn.classList.remove('uk-button-disabled');

		req = await Solver.api.cart.get();

		Solver.cart.data = req.data;
		return;
	}

	req = await Solver.api.cart.notes('');
	btn.classList.add('uk-button-disabled');

	req = await Solver.api.cart.get();
	Solver.cart.data = req.data;
};

/**
 * Updates the cart UI
 * @param { object } cart - http response of cart object
 * @return { object } cart object
 */
Solver.cart.ui = async function (cart) {
	if (!cart) return;

	const cartHTML = document.querySelector('[data-cart]');

	if (cartHTML) {
		const section = cartHTML.getAttribute('data-cart');

		const req = await fetch('/?sections=' + section);

		if (req.error) {
			const message = req.error.message ? req.error.message : req.error;
			console.error(message);
			UIkit.notification(message, { status: 'danger' });
			return { error: message };
		}

		let markup = await req.json();
		markup = markup[section];
		markup = new DOMParser().parseFromString(markup, 'text/html');
		markup = markup.querySelector(`[data-cart="${section}"]`);
		const cartItems = markup.querySelector(`[data-cart="${section}"] [data-cart-items]`);
		const cartSummary = markup.querySelector(`[data-cart="${section}"] [data-cart-summary]`);
		const cartEmpty = markup.querySelector(`[data-cart="${section}"] [data-cart-empty]`);

		if (cartHTML.querySelector('[data-cart-items]') && cartItems) {
			cartHTML.querySelector('[data-cart-items]').innerHTML = cartItems.innerHTML;
			cartHTML.querySelector('[data-cart-summary]').innerHTML = cartSummary.innerHTML;
		}

		if (!cartHTML.querySelector('[data-cart-items]') && cartItems) {
			cartHTML.querySelector('[data-cart-empty]').remove();
			cartHTML.appendChild(cartItems);
			cartHTML.appendChild(cartSummary);
		}

		if (cartEmpty) {
			cartHTML.querySelector('[data-cart-items]').remove();
			cartHTML.querySelector('[data-cart-summary]').remove();
			cartHTML.appendChild(cartEmpty);
		}
	}

	const cartCount = document.querySelector('[data-cart-count]');
	if (cartCount) cartCount.innerText = cart.item_count;

	const cartQuantity = document.querySelector('[data-cart-quantity]');

	if (cartQuantity) cartQuantity.innerText = cart.item_count;

	return cart;
};

/**
 * Gets http cart object from http request
 * @param { object } event|optional - user generated DOM event
 * @return { object } cart object
 */
Solver.cart.get = async function (event) {
	if (event && event.preventDefault) event.preventDefault();

	const req = await Solver.api.cart.get();

	if (!req || (req && req.error)) {
		const message = req.error.message ? req.error.message : req.error;
		console.error(message);
		UIkit.notification(message, { status: 'danger' });
		return { error: message };
	}

	Solver.cart.ui(req.data);
	window.Solver.cart.data = req.data;

	return { data: req.data };
};

/**
 * Adds quanity by to cart by variant ID
 * @param { string } variantID - product variant id
 * @param { number } quantity - amount to increment
 * @params { string|number } selling_plan - app based selling plan
 * @return { object } cart object
 */
Solver.cart.add = async function (event, variantID, quantity, selling_plan = null) {
	if (event && event.preventDefault) event.preventDefault();

	let req = await Solver.api.cart.add(variantID, quantity, selling_plan);

	const overlay = document.querySelector('[data-cart] [data-cart-overlay]');
	if (overlay) overlay.classList.remove('uk-hidden');

	if (!req) {
		const message = 'Request could not be completed';
		console.error(message);
		UIkit.notification(message, { status: 'danger' });
		if (overlay) overlay.classList.add('uk-hidden');
		return { error: message };
	}

	if (req && req.error) {
		const message = 'Could not add to cart';
		console.error(message);
		UIkit.notification(message, { status: 'danger' });
		if (overlay) overlay.classList.add('uk-hidden');
		return { error: message };
	}

	req = await Solver.cart.get();

	UIkit.offcanvas('#cart-drawer').show();

	if (overlay) overlay.classList.add('uk-hidden');

	return { data: req.data };
};

/**
 * Adds quanity by to cart by variant ID
 * @param { string } id - key(id) of of line item to increment or decrement quantity on
 * @param { number } quantity - amount to increment or decrement per variant id
 * @return { object } cart object
 */
Solver.cart.change = async function (event, id, quantity = 0) {
	if (event && event.preventDefault) event.preventDefault();

	if (!id) return;

	const overlay = document.querySelector('[data-cart] [data-cart-overlay]');
	if (overlay) overlay.classList.remove('uk-hidden');

	let req = await Solver.api.cart.change({
		id: id.toString(),
		quantity: parseInt(quantity)
	});

	if (!req) {
		const message = 'Request could not be completed';
		console.error(message);
		UIkit.notification(message, { status: 'danger' });
		if (overlay) overlay.classList.add('uk-hidden');
		return { error: message };
	}

	if (req.error) {
		const message = req.error.message ? req.error.message : req.error;
		console.error(message);
		UIkit.notification(message, { status: 'danger' });
		if (overlay) overlay.classList.add('uk-hidden');
		return { error: message };
	}

	req = await Solver.cart.get();

	if (overlay) overlay.classList.add('uk-hidden');

	return { data: req.data };
};
